import templateUrl from './password-strength.component.html';

export const PasswordStrengthComponent = {
    templateUrl,
    bindings: {
        password: "<",
        passwordValidator: "<"
    },
    controller: class PasswordStrengthComponent {
        $onChanges() {
            if (!this.passwordValidator) {
                this.requiredValidationRules = [];
                return;
            }

            this.requiredValidationRules = this.passwordValidator.validationRules
                .filter(p => p.isRequired())
                .map(rule => ({
                    description: rule.description,
                    isSatisfied: rule.isSatisfiedBy(this.password || "")
                }));
            this.passwordStrength = this.passwordValidator.calculateStrength(this.password) * 100;
            this.isValid = this.passwordValidator.validate(this.password);
        }
    }
}
